var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 10L14 14M6.66667 11.3333C4.08934 11.3333 2 9.244 2 6.66667C2 4.08934 4.08934 2 6.66667 2C9.244 2 11.3333 4.08934 11.3333 6.66667C11.3333 9.244 9.244 11.3333 6.66667 11.3333Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"square","strokeLinejoin":"round"}));
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
